// extracted by mini-css-extract-plugin
module.exports = {"clientStyle":"_3_eKMKWxTFu9iXBzjnXNkD","deleteClientStyle":"_3TBbXpTtDmiCILYkVJWCCU"};